/**
 * Copyright Highway9 Networks Inc.
 */
import { createContext } from "react";
import { createContextualCan } from "@casl/react";
import type { AppAbility } from "../types/rbac";
import { createEmptyAbility } from "./defineAbility";

export const AbilityContext = createContext<AppAbility>(createEmptyAbility());

/** Declarative permission gate — renders children only when the user is allowed. */
export const Can = createContextualCan(AbilityContext.Consumer);
